import React, { useRef, useMemo, useCallback } from 'react';
import styled from 'styled-components/macro';
import gsap from 'gsap';

import { viewport } from '../../../../common/config';
import useMediaStore from '../../../../common/store/useMediaStore';
import useFlavorStore from '../../../../common/store/useFlavorStore';
import WonderfulText from '../../../../common/components/svg/WonderfulText';
import Stroke, { Wrapper as _Stroke, Path as _Stroke_Path } from '../../../../common/components/svg/Stroke';
import Container from '../Container';
import { getVh } from '../utils';
import useTriggerAnimation from '../useTriggerAnimation';
import useParallax from '../useParallax';

const Text = styled.div`
  width: 250rem;
  transform: rotate(-10deg);

  @media screen and (min-width: ${viewport.sm}) {
    width: 320rem;
  }

  @media screen and (min-width: ${viewport.md}) {
    width: 400rem;
  }

  ${_Stroke} {
    transform: translateY(50%) rotateY(0);
    left: 48%;
    width: 118rem;

    @media screen and (min-width: ${viewport.sm}) {
      width: 151rem;
    }

    @media screen and (min-width: ${viewport.md}) {
      width: 200rem;
    }
  }

  ${_Stroke_Path} {
    stroke-dasharray: 118;
    stroke-dashoffset: 118;

    @media screen and (min-width: ${viewport.sm}) {
      stroke-dasharray: 151;
      stroke-dashoffset: 151;
    }

    @media screen and (min-width: ${viewport.md}) {
      stroke-dasharray: 200;
      stroke-dashoffset: 200;
    }
  }
`;

const Wonderful = () => {
  /**
   * Hooks
   */
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const md = useMediaStore(useCallback(state => state.md, []));

  const ref = {
    container: useRef<HTMLElement>(null),
    path: useRef<SVGPathElement>(null),
    text: useRef<HTMLDivElement>(null)
  }

  const top = useMemo(() => getVh("faqs", 0.05), []);

  useTriggerAnimation(ref.container, top, () => {
    gsap.to(ref.path.current, {
      duration: 1.5,
      ease: "power2.out",
      strokeDashoffset: "0"
    });
  });

  useParallax(ref.text, top, 50);

  /**
   * Not hook
   */
  const style = md ? { right: "15vw" } : { left: "5vw" };

  /**
   * Render
   */
  return (
    <Container
      ref={ref.container}
      top={top}
      style={style}
    >
      <Text ref={ref.text}>
        <WonderfulText color={`var(--${flavor})`} />
        <Stroke pathRef={ref.path} color={`var(--${flavor})`} />
      </Text>
    </Container>
  );
}

export default Wonderful;